<template>
  <ReferenceComponentParentList
    :searchList="result"
    :componentType="componentType"
    :selectedIndex="selectedIndex"
    :isLast="isLast"
    class="reference-list_md"
    @onClick="onEpicSelected"
    @onScroll="onScroll"
  >
    <template #header>
      <BaseSubHeading
        weight="600"
        size="medium"
        color="monochrome-06"
      >
        Epics
      </BaseSubHeading>
    </template>

    <template #item="{ option }">
      <div class="reference-list__item-in">
        <span>
          <BaseSubHeading
            weight="400"
            size="medium"
            color="monochrome-06"
          >
            E-{{ option.sequenceNumber }}
          </BaseSubHeading>
        </span>

        <span>
          <BaseSubHeading
            weight="400"
            size="medium"
            color="monochrome-07"
          >
            {{ option.name }}
          </BaseSubHeading>
        </span>
        <span>
          <BaseSubHeading
            weight="400"
            size="medium"
            color="monochrome-05"
            darkColor="monochrome-04"
          >
            {{ option.percentComplete }}% Done
          </BaseSubHeading>
        </span>
      </div>
    </template>
  </ReferenceComponentParentList>
</template>

<script lang="ts">
import { mixins, Options } from "vue-class-component"
import { Action } from "s-vuex-class"

import ReferenceComponentListCommon from "@/components/Reference/helpers/ReferenceComponentListCommon"
import ReferenceComponentParentList from "@/components/Reference/helpers/ReferenceComponentParentList.vue"

import { Epic, FilterEpic, Project, ServerResponse } from "@/models"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"
import { Actions } from "@/store"
import { parsingServerResponseContent } from "@/utils"

const components = {
  ReferenceComponentParentList
}

@Options({
  name: "EpicList",
  components
})
export default class extends mixins(ReferenceComponentListCommon) {
  @Action(Actions.SEARCH_EPIC) searchEpic: (filter: FilterEpic) => Promise<ServerResponse<Epic>>
  @Action(Actions.GET_PROJECTS) getProjects: () => Promise<Project[]>

  componentType = ReferenceType.EPIC
  waitTitle = "reference.search.epic"
  result: Epic[] = []
  isLast = true

  async created() {
    this.filter = new FilterEpic()
    this.filter.projectIds = [this.projectId]
    this.searchAction = this.onSearchEpic
  }

  onEnterHandler() {
    if (this.result) {
      this.onEpicSelected(this.result[this.selectedIndex])
    }
  }

  onEpicSelected(payload) {
    this.selectItem({
      item: payload,
      payload: {}
    })
  }

  queryUpdated(q) {
    this.filter.page = 1
    this.filter.q = q.substring(1)
    this.search()
  }

  async onSearchEpic() {
    const serverResponse = await this.searchEpic(this.filter)
    if (!serverResponse) return
    this.result = parsingServerResponseContent({
      originalContent: this.result,
      serverResponseContent: serverResponse.content,
      numberOfPage: serverResponse.pageable.pageNumber
    })
    this.isLast = serverResponse.last
  }
}
</script>
